import Vue from 'vue';

Vue.component('flash', require('./Flash.vue').default);
Vue.component('no-data', require('./NoDataLoaded.vue').default);
Vue.component('custom-tooltip', require('./CustomTooltip.vue').default);